"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Data = Data;
exports.ActionData = ActionData;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _consts = require("./consts");

var _utils = require("./utils");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Data(_ref) {
  var children = _ref.children,
      width = _ref.width,
      truncated = _ref.truncated,
      alignment = _ref.alignment,
      disabled = _ref.disabled,
      noPadding = _ref.noPadding,
      props = _objectWithoutProperties(_ref, ["children", "width", "truncated", "alignment", "disabled", "noPadding"]);

  var widthClasses = (0, _classnames.default)((0, _utils.widthClass)(width), 'co-table__cell');
  var allowedModifiers = {
    truncatedCell: truncated,
    alignment: alignment,
    disabled: disabled,
    noPadding: noPadding
  };
  return _react.default.createElement(_styler.default, {
    className: widthClasses,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("td", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
}

function ActionData(_ref2) {
  var children = _ref2.children,
      disabled = _ref2.disabled,
      width = _ref2.width,
      truncated = _ref2.truncated,
      noPadding = _ref2.noPadding,
      props = _objectWithoutProperties(_ref2, ["children", "disabled", "width", "truncated", "noPadding"]);

  var classes = (0, _classnames.default)('co-table__column--actions', (0, _utils.widthClass)(width));
  var allowedModifiers = {
    truncatedCell: truncated,
    disabled: disabled,
    noPadding: noPadding
  };
  return _react.default.createElement(_styler.default, {
    className: classes,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("td", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
}

Data.ALIGNMENT = _consts.ALIGNMENTS;
Data.WIDTH = _consts.WIDTHS;
Data.displayName = 'Table.Data';
ActionData.displayName = 'Table.ActionData';
Data.propTypes = {
  children: _propTypes.any,

  /** {---} One of: @@Table.Data.ALIGNMENT.LEFT@@ @@Table.Data.ALIGNMENT.CENTER@@ @@Table.Data.ALIGNMENT.RIGHT@@ */
  alignment: _consts.oneOfAlignments,

  /** {const} One of: @@Table.Data.WIDTH[X]@@ (X between 5 and 100, in increments of 5) */
  width: _consts.oneOfBreakpoints,
  disabled: _propTypes.bool,
  noPadding: _propTypes.bool,
  truncated: _propTypes.bool
};
ActionData.propTypes = {
  /** {---} One of:
   * @@<Button>@@
   * @@<Link>@@
   * @@<Popup>@@
   * @@<Dropdown>@@ */
  children: _propTypes.any.isRequired,

  /** {const} One of: @@Table.Data.WIDTHS[X]@@ (X between 5 and 100, in increments of 5) */
  width: _consts.oneOfBreakpoints,
  disabled: _propTypes.bool,
  noPadding: _propTypes.bool,
  truncated: _propTypes.bool
};
Data.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table.Data",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "alignment": {
      "type": {
        "name": "custom",
        "raw": "oneOfAlignments"
      },
      "required": false,
      "description": "{---} One of: @@Table.Data.ALIGNMENT.LEFT@@ @@Table.Data.ALIGNMENT.CENTER@@ @@Table.Data.ALIGNMENT.RIGHT@@"
    },
    "width": {
      "type": {
        "name": "custom",
        "raw": "oneOfBreakpoints"
      },
      "required": false,
      "description": "{const} One of: @@Table.Data.WIDTH[X]@@ (X between 5 and 100, in increments of 5)"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "noPadding": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
ActionData.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table.ActionData",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} One of:\n@@<Button>@@\n@@<Link>@@\n@@<Popup>@@\n@@<Dropdown>@@"
    },
    "width": {
      "type": {
        "name": "custom",
        "raw": "oneOfBreakpoints"
      },
      "required": false,
      "description": "{const} One of: @@Table.Data.WIDTHS[X]@@ (X between 5 and 100, in increments of 5)"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "noPadding": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};